"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetStxSupplyLegacyFormatResponseToJSON = exports.GetStxSupplyLegacyFormatResponseFromJSONTyped = exports.GetStxSupplyLegacyFormatResponseFromJSON = void 0;
function GetStxSupplyLegacyFormatResponseFromJSON(json) {
    return GetStxSupplyLegacyFormatResponseFromJSONTyped(json, false);
}
exports.GetStxSupplyLegacyFormatResponseFromJSON = GetStxSupplyLegacyFormatResponseFromJSON;
function GetStxSupplyLegacyFormatResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'unlockedPercent': json['unlockedPercent'],
        'totalStacks': json['totalStacks'],
        'totalStacksFormatted': json['totalStacksFormatted'],
        'unlockedSupply': json['unlockedSupply'],
        'unlockedSupplyFormatted': json['unlockedSupplyFormatted'],
        'blockHeight': json['blockHeight'],
    };
}
exports.GetStxSupplyLegacyFormatResponseFromJSONTyped = GetStxSupplyLegacyFormatResponseFromJSONTyped;
function GetStxSupplyLegacyFormatResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'unlockedPercent': value.unlockedPercent,
        'totalStacks': value.totalStacks,
        'totalStacksFormatted': value.totalStacksFormatted,
        'unlockedSupply': value.unlockedSupply,
        'unlockedSupplyFormatted': value.unlockedSupplyFormatted,
        'blockHeight': value.blockHeight,
    };
}
exports.GetStxSupplyLegacyFormatResponseToJSON = GetStxSupplyLegacyFormatResponseToJSON;
//# sourceMappingURL=GetStxSupplyLegacyFormatResponse.js.map